import { useState, useEffect, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { H5 } from 'components/Typography';

import Input from '../Input';
import InputLabel from '../InputLabel';
import InputDescription from '../InputDescription';
import InputArea from '../InputArea';
import InputError from '../InputError';
import InputErrorText from '../InputErrorText';
import InputPrivate from '../InputPrivate';

function InputTextarea({
	name,
	label,
	description,
	placeholder,
	defaultValue,
	onChange,
	updateOnChange,
	onFocus,
	onBlur,
	index,
	isFaded,
	required,
	error,
	disabled,
	type,
	isTransparent,
	isPrivateEnabled,
	isOffFocus
}) {
	const theme = useContext(ThemeContext);
	const [value, setValue] = useState(defaultValue);
	const [delayedError, setDelayedError] = useState(error);
	const [valueOnDelayedError, setValueOnDelayedError] = useState(value);
	const [isPrivate, onChangePrivate] = useState(false);

	useEffect(() => {
		onChangeHelper(defaultValue);
	}, [defaultValue]);

	useEffect(() => {
		// console.log('hasError?', value, error);
		if (error != '' && error != null) {
			setDelayedError(error);
			setValueOnDelayedError(value);
		}
	}, [error]);

	useEffect(() => {
		onChangeHelper(value);
	}, [isPrivate]);

	const onChangeHelper = (newValue) => {
		setValue(newValue);
		onChange(name, newValue + (isPrivate ? ';private/' : ''));
		if (updateOnChange) updateOnChange(name, isPrivate ? '비공개' : newValue);
	};

	return (
		<Input isFaded={isFaded} isOffFocus={isOffFocus}>
			<InputLabel error={error} required={required}>
				<H5
					opacity={0.66}
					isLabel={true}
				>
					{label}
				</H5>
			</InputLabel>
			{description && <InputDescription>{description}</InputDescription>}
			<InputArea
				type={type ? type : 'text'}
				placeholder={placeholder}
				onChange={(e) => onChangeHelper(e.target.value)}
				onFocus={() => onFocus(index)}
				onBlur={() => onBlur(index)}
				value={value}
				required={required}
				isFaded={isFaded}
				error={error != null && error != '' && valueOnDelayedError == value}
				disabled={disabled}
				isTransparent={isTransparent}
			/>
			{isPrivateEnabled && <InputPrivate isPrivate={isPrivate} onChangePrivate={onChangePrivate} />}
			<InputError error={error}>
				<InputErrorText error={error}>{delayedError}</InputErrorText>
			</InputError>
		</Input>
	);
}

export default InputTextarea;